// extracted by mini-css-extract-plugin
export var aboveInput = "_no-0";
export var actionButton = "_no-5";
export var actionButtonContainer = "_no-1";
export var actionIcon = "_no-6";
export var aiInfoContainer = "_no-2";
export var attachmentWrapper = "_no-7";
export var bold = "_no-3";
export var checkIcon = "_no-8";
export var clickingRecipientBar = "_no-11";
export var commentThreadSwitch = "_no-a";
export var draftImage = "_no-b";
export var draftImageContainer = "_no-c";
export var draftImages = "_no-e";
export var editButton = "_no-g";
export var editor = "_no-f";
export var editorContainer = "_no-y";
export var editorErrorTooltipWrapper = "_no-9";
export var headerDivider = "_no-h";
export var icon = "_no-i";
export var info = "_no-j";
export var internal = "_no-n";
export var internalDivider = "_no-k";
export var internalMessage = "_no-l";
export var messageInputCard = "_no-m";
export var messageInputForm = "_no-o";
export var messageInputFormInternal = "_no-p";
export var options = "_no-q";
export var publicMessageCustomer = "_no-s";
export var publicMessageMerchant = "_no-r";
export var removeImageButton = "_no-d";
export var replyButtons = "_no-t";
export var showSignatureButton = "_no-u";
export var spinner = "_no-v";
export var verticalButtonDivider = "_no-4";
export var visibilitySelector = "_no-w";
export var warning = "_no-x";
export var wrappingText = "_no-z";
export var writingInternalNoteTopBorder = "_no-10";